(function() {
  var cartRecommendationsStorageKey = 'verychiCartRecommendationsHtml';
  var cartRecommendationsStorageTimeKey = 'verychiCartRecommendationsSavedAt';

  window.VerychiCartRecommendations = window.VerychiCartRecommendations || {};
  window.VerychiCartRecommendations.clear = function() {
    try {
      sessionStorage.removeItem(cartRecommendationsStorageKey);
    } catch (err) {}
    try {
      localStorage.removeItem(cartRecommendationsStorageKey);
      localStorage.removeItem(cartRecommendationsStorageTimeKey);
    } catch (err) {}
    window.__CartMetafieldRecommendationsHtml = '';
    window.__CartMetafieldRecommendationsPending = false;
    var mount = document.getElementById('AjaxCartRecommendations');
    if (mount) mount.innerHTML = '';
  };

  function getProductHandleFromHref(href) {
    if (!href) return '';

    try {
      var url = new URL(href, window.location.origin);
      var match = url.pathname.match(/\/products\/([^\/]+)/);
      return match && match[1] ? decodeURIComponent(match[1]).toLowerCase() : '';
    } catch (err) {
      var fallback = String(href).split('?')[0].match(/\/products\/([^\/]+)/);
      try {
        return fallback && fallback[1] ? decodeURIComponent(fallback[1]).toLowerCase() : '';
      } catch (err2) {
        return fallback && fallback[1] ? fallback[1].toLowerCase() : '';
      }
    }
  }

  function getCartProductHandles() {
    var handles = {};
    var links = document.querySelectorAll('#CartDrawer .ajaxcart__product-name[href], #CartDrawer .ajaxcart__product-image[href]');

    Array.prototype.forEach.call(links, function(link) {
      var handle = getProductHandleFromHref(link.getAttribute('href'));
      if (handle) handles[handle] = true;
    });

    return handles;
  }

  function filterCartRecommendations(scope) {
    var grid = scope.querySelector('.ajaxcart-recommendations__grid');
    var recs = scope.querySelector('.ajaxcart-recommendations');
    if (!grid || !recs) return true;

    var cartHandles = getCartProductHandles();
    var hasVisibleItems = false;

    Array.prototype.forEach.call(grid.querySelectorAll('.ajaxcart-recommendations__item'), function(item) {
      var link = item.querySelector('.ajaxcart-recommendations__link[href]');
      var handle = link ? getProductHandleFromHref(link.getAttribute('href')) : '';

      if (handle && cartHandles[handle]) {
        item.parentNode.removeChild(item);
        return;
      }

      hasVisibleItems = true;
    });

    if (!hasVisibleItems) {
      scope.innerHTML = '';
      return false;
    }

    return true;
  }

  function renderCartMetafieldRecommendations() {
    var mount = document.getElementById('AjaxCartRecommendations');
    var storageKey = cartRecommendationsStorageKey;
    var storageTimeKey = cartRecommendationsStorageTimeKey;
    if (!mount) return;
    mount.innerHTML = '';
    if (!document.querySelector('#CartDrawer .ajaxcart__product')) {
      window.VerychiCartRecommendations.clear();
      return;
    }

    if (!window.__CartMetafieldRecommendationsPending) {
      try {
        var storedHtml = sessionStorage.getItem(storageKey);
        if (!storedHtml || !storedHtml.trim()) {
          storedHtml = localStorage.getItem(storageKey);
        }
        if (storedHtml && storedHtml.trim()) {
          window.__CartMetafieldRecommendationsHtml = storedHtml;
          window.__CartMetafieldRecommendationsPending = true;
        }
      } catch (err) {}
    }

    if (!window.__CartMetafieldRecommendationsPending) return;
    if (!window.__CartMetafieldRecommendationsHtml) {
      var tpl = document.getElementById('CartMetafieldRecommendationsTemplate');
      if (tpl && tpl.innerHTML.trim()) {
        window.__CartMetafieldRecommendationsHtml = tpl.innerHTML;
      }
    }
    if (!window.__CartMetafieldRecommendationsHtml || !window.__CartMetafieldRecommendationsHtml.trim()) return;
    try {
      sessionStorage.setItem(storageKey, window.__CartMetafieldRecommendationsHtml);
    } catch (err) {}
    try {
      localStorage.setItem(storageKey, window.__CartMetafieldRecommendationsHtml);
      localStorage.setItem(storageTimeKey, String(Date.now()));
    } catch (err) {}
    mount.innerHTML = window.__CartMetafieldRecommendationsHtml;
    if (!filterCartRecommendations(mount)) {
      window.__CartMetafieldRecommendationsPending = false;
      if (window.theme && typeof window.theme.sizeCartDrawerFooter === 'function') {
        setTimeout(window.theme.sizeCartDrawerFooter, 0);
      }
      return;
    }
    window.__CartMetafieldRecommendationsPending = false;
    addCartRecommendationsArrows(mount);
    bindCartRecommendationsDrag(mount);
    if (window.theme && typeof window.theme.sizeCartDrawerFooter === 'function') {
      setTimeout(window.theme.sizeCartDrawerFooter, 0);
    }
  }

  function addCartRecommendationsArrows(scope) {
    var recs = scope.querySelector('.ajaxcart-recommendations');
    var grid = scope.querySelector('.ajaxcart-recommendations__grid');
    if (!recs || !grid || recs.querySelector('.ajaxcart-recommendations__arrow')) return;

    var prev = document.createElement('button');
    var next = document.createElement('button');
    prev.type = 'button';
    next.type = 'button';
    prev.className = 'ajaxcart-recommendations__arrow ajaxcart-recommendations__arrow--prev';
    next.className = 'ajaxcart-recommendations__arrow ajaxcart-recommendations__arrow--next';
    prev.setAttribute('aria-label', 'Предишни продукти');
    next.setAttribute('aria-label', 'Следващи продукти');
    prev.innerHTML = '&lsaquo;';
    next.innerHTML = '&rsaquo;';

    function scrollByPage(direction) {
      var amount = Math.max(grid.clientWidth * 0.72, 160);
      grid.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    function updateArrows() {
      var hasOverflow = grid.scrollWidth > grid.clientWidth + 4;
      recs.classList.toggle('ajaxcart-recommendations--has-arrows', hasOverflow);
      prev.disabled = !hasOverflow || grid.scrollLeft <= 2;
      next.disabled = !hasOverflow || grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
    }

    prev.addEventListener('click', function() { scrollByPage(-1); });
    next.addEventListener('click', function() { scrollByPage(1); });
    grid.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    recs.appendChild(prev);
    recs.appendChild(next);
    setTimeout(updateArrows, 0);
  }

  function bindCartRecommendationsDrag(scope) {
    var grid = scope.querySelector('.ajaxcart-recommendations__grid');
    if (!grid || grid.getAttribute('data-drag-bound') === '1') return;

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;
    var suppressClick = false;

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      grid.classList.remove('is-dragging');
      if (moved) {
        suppressClick = true;
        setTimeout(function() {
          suppressClick = false;
          moved = false;
        }, 150);
      }
    }

    grid.addEventListener('mousedown', function(event) {
      if (event.button !== 0) return;
      isDown = true;
      moved = false;
      startX = event.pageX;
      scrollLeft = grid.scrollLeft;
      grid.classList.add('is-dragging');
    });

    grid.addEventListener('mousemove', function(event) {
      if (!isDown) return;
      var walk = event.pageX - startX;
      if (Math.abs(walk) > 8) {
        moved = true;
        event.preventDefault();
      }
      grid.scrollLeft = scrollLeft - (walk * 1.15);
    });

    grid.addEventListener('mouseleave', endDrag);
    document.addEventListener('mouseup', endDrag);

    grid.addEventListener('click', function(event) {
      if (event.target.closest && event.target.closest('.ajaxcart-recommendations__quick-add')) return;
      var productLink = event.target.closest && event.target.closest('.ajaxcart-recommendations__link');

      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
        moved = false;
        return;
      }

      if (!productLink || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var href = productLink.getAttribute('href');
      if (!href || href === '#') return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(href);
    }, true);

    grid.setAttribute('data-drag-bound', '1');
  }

  var cartRecommendationEventsBound = false;

  function bindCartRecommendationEvents() {
    if (cartRecommendationEventsBound || !window.jQuery) return false;
    window.jQuery(document.body).on('ajaxCart.afterCartLoad.verychiCartRecommendations', function() {
      renderCartMetafieldRecommendations();
      if (window.VerychiWishlist && typeof window.VerychiWishlist.syncAll === 'function') {
        window.VerychiWishlist.syncAll();
      }
    });
    cartRecommendationEventsBound = true;
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCartRecommendationEvents, { once: true });
  } else {
    bindCartRecommendationEvents();
  }
  window.addEventListener('verychi:product-runtime-ready', bindCartRecommendationEvents);
})();
